/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'boar',
    quality: 0.2,
    strength: 1,
    willpower: 1
}